import { useState } from "react";
import { Select } from "antd";
import { motion } from "framer-motion";
import "antd/dist/reset.css";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function BusinessForm() {
  const [logo, setLogo] = useState(null);
  const [icon, setIcon] = useState(null);

  return (
    <motion.div
      className=" card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Business Settings
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0 p-4"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        {/* BASIC INFO */}
        <motion.div
          className="row g-3"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          {["Company Name", "Email Address", "Phone", "Fax", "Web"].map(
            (field, i) => (
              <motion.div
                key={i}
                className="col-md-6"
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.05 }}
              >
                <motion.input
                  whileFocus={{ scale: 1.02 }}
                  className="form-control"
                  placeholder={field}
                />
              </motion.div>
            )
          )}
        </motion.div>

        {/* IMAGES */}
        <motion.h6
          className="mt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          Company Images
        </motion.h6>

        {/* LOGO */}
        <motion.div
          className="border p-3 mb-3 d-flex justify-content-between align-items-center rounded"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25 }}
          whileHover={{ scale: 1.01 }}
        >
          <div>
            <div>Company Logo</div>

            {logo && (
              <motion.img
                src={URL.createObjectURL(logo)}
                alt="logo"
                style={{ width: 80, borderRadius: 8, marginTop: 10 }}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
              />
            )}
          </div>

          <div>
            <label className="btn btn-outline-primary btn-sm me-2 mb-0">
              Change
              <input
                type="file"
                hidden
                onChange={(e) => setLogo(e.target.files[0])}
              />
            </label>

            {logo && (
              <motion.button
                whileTap={{ scale: 0.9 }}
                className="btn btn-outline-danger btn-sm"
                onClick={() => setLogo(null)}
              >
                Cancel
              </motion.button>
            )}
          </div>
        </motion.div>

        {/* ICON */}
        <motion.div
          className="border p-3 d-flex justify-content-between align-items-center rounded"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          whileHover={{ scale: 1.01 }}
        >
          <div>
            <div>Company Icon</div>

            {icon && (
              <motion.img
                src={URL.createObjectURL(icon)}
                alt="icon"
                style={{ width: 50, borderRadius: 6, marginTop: 10 }}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
              />
            )}
          </div>

          <div>
            <label className="btn btn-outline-primary btn-sm me-2 mb-0">
              Change
              <input
                type="file"
                hidden
                onChange={(e) => setIcon(e.target.files[0])}
              />
            </label>

            {icon && (
              <motion.button
                whileTap={{ scale: 0.9 }}
                className="btn btn-outline-danger btn-sm"
                onClick={() => setIcon(null)}
              >
                Cancel
              </motion.button>
            )}
          </div>
        </motion.div>

        {/* ADDRESS */}
        <motion.h6
          className="mt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.35 }}
        >
          Address Information
        </motion.h6>

        <motion.textarea
          className="form-control mb-3"
          placeholder="Address"
          whileFocus={{ scale: 1.02 }}
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        />

        <div className="row g-3">
          {["Country", "City", "State"].map((label, i) => (
            <motion.div
              key={label}
              className="col-md-3"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.45 + i * 0.05 }}
            >
              <label>{label}</label>
              <Select className="w-100" placeholder={`Select ${label}`} />
            </motion.div>
          ))}

          <motion.div
            className="col-md-3"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
          >
            <label>Postal Code</label>
            <motion.input
              whileFocus={{ scale: 1.02 }}
              className="form-control"
              placeholder="Postal Code"
            />
          </motion.div>
        </div>

        {/* BUTTONS */}
        <motion.div
          className="d-flex justify-content-end mt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7 }}
        >
          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-danger me-2"
          >
            Cancel
          </motion.button>

          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-outline-primary"
          >
            Save
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}